import { render } from "./HdDropdownItemButton.vue?vue&type=template&id=04e3f0bf"
import script from "./HdDropdownItemButton.vue?vue&type=script&lang=js"
export * from "./HdDropdownItemButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__